import { Button } from '@/common-utils/components/ui/button';
import TooltipHelper from '../../../tooltip/TooltipHelper';
import Entity from '../../../entity/Entity';
import ICONS from '@/common-utils/enums/icons';
import PropTypes from 'prop-types';

/**
 * @param root0
 * @param root0.columnId
 * @param root0.filterValue
 * @param root0.removeFilter
 * @param root0.addFilter
 * @param root0.setLaunchSearch
 * @param root0.filters
 * @param root0.disableSearchButton
 * @returns FilterButtons
 */
function FilterButtons({ columnId, filterValue, addFilter, setLaunchSearch, filters = undefined, disableSearchButton }) {

    return (
        <TooltipHelper
            asChild
            trigger={
                <Button
                    onClick={() => {
                        if (filterValue) {
                            addFilter(columnId, filterValue);
                        }
                        if (filters?.length > 0) {
                            filters.forEach(element => {
                                if (element.value) {
                                    return addFilter(element.filter, element.value);
                                }
                            });
                        }
                        setLaunchSearch(true);
                    }}
                    icon={ICONS.SEARCH}
                    variant='ghost'
                    className={'h-9 rounded-lg'}
                    disabled={disableSearchButton}
                />
            }
            content={
                <Entity entity={'button.search'} />
            }
        />
    );
}

export default FilterButtons;

FilterButtons.propTypes = {
    columnId: PropTypes.string.isRequired,
    filterValue: PropTypes.any,
    addFilter: PropTypes.func.isRequired,
    setLaunchSearch: PropTypes.func.isRequired,
    filters: PropTypes.array,
    disableSearchButton: PropTypes.bool
};